import { Base } from '../base-component';
import { AnalyticsService } from '../../services/analytics.service';

import './form-item-mail-form.component.scss';

export class FormItemMailForm extends Base {
	applyForm: HTMLFormElement;
	applyFormSubmit: Element[];

	subjectField: HTMLFormElement;
	emailField: HTMLFormElement;
	recipientField: HTMLFormElement;

	naturalResources: HTMLFormElement;

	constructor(element: Element) {
		super(element);
	}

	init() {
		this.applyForm = this.element.querySelector('form') as HTMLFormElement;
		this.applyFormSubmit = Array.from(this.element.querySelectorAll('.js-apply-now__button'));
		this.subjectField = this.element.querySelector('input[name="subject"]');
		this.emailField = this.element.querySelector('input[name="email"]');
		this.recipientField = this.element.querySelector('input[name="recipient"]');

		this.naturalResources = this.element.querySelector('.js-help-required');

		if (this.naturalResources) {
			this.updateEmailForNaturalResources(this.naturalResources.value);
		}
	}

	bindEvents() {
		this.applyFormSubmit.map((item) => item.addEventListener('click', (event) => {
			const formFields: any = this.applyForm.querySelectorAll('input, select');
			const validation = this.validationService.validate(formFields);
			const valid = Array.from(this.applyForm.querySelectorAll('.form__group--error'));
			if (valid.length === 0) {
				this.submitForm(this.applyForm);
			}
		}));

		if (this.naturalResources) {
			this.naturalResources.addEventListener('change', () => { this.updateEmailForNaturalResources(this.naturalResources.value); });
		}
	}

	resetForm() {
		if (this.applyForm) {
			this.applyForm.reset();
			const formContainerLoader = this.element.querySelector('.form__loader--container');
			const formContainerFields = this.element.querySelector('.form__fields--container');
			const formContainerThankyou = this.element.querySelector('.form__thankyou--container');

			formContainerThankyou.classList.remove('active');
			formContainerFields.classList.remove('hidden');
		}
	}

	updateEmailForNaturalResources(select) {
		let _subject = 'Natural Resources - Mining Call Me Back';
		let _email = 'naturalresources@standardbank.co.za';
		let _recipient = 'naturalresources@standardbank.co.za';

		switch (select) {
			case 'Oil and Gas':
				_subject = 'Natural Resources - Oil and Gas Call Me Back';
				_email = 'naturalresources@standardbank.co.za';
				_recipient = 'naturalresources@standardbank.co.za';
				break;
			case 'Mining':
				_subject = 'Natural Resources - Mining Call Me Back';
				_email = 'naturalresources@standardbank.co.za';
				_recipient = 'naturalresources@standardbank.co.za';
				break;
			case 'Renewable Energy':
				_subject = 'Natural Resources - Renewable Energy Call Me Back';
				_email = 'solarpv@standardbank.co.za';
				_recipient = 'solarpv@standardbank.co.za';
				break;
		}

		if (this.subjectField) {
			this.subjectField.value = _subject;
		}
		if (this.emailField) {
			this.emailField.value = _email;
		}
		if (this.recipientField) {
			this.recipientField.value = _recipient;
		}
	}

	submitForm(form: HTMLFormElement) {
		// success screens
		const loader = form.querySelector('.form__loader--container');
		const thankYou = form.querySelector('.form__thankyou--container');
		const fieldsContainer: any = form.querySelector('.form__fields--container');

		// fields
		const fields: any = this.formsService.serializeForm(form);

		// loader + hide form
		loader.classList.add('active');
		fieldsContainer.classList.add('hidden');

		// variables
		const analyticsService = new AnalyticsService();
		const url = '/services/genericform.jsp';
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				'Access-Control-Allow-Origin': '*',
				'X-Requested-With': 'XMLHttpRequest'
			}
		};

		// service
		this.formsService.postForm(url, fields, config).then(response => {
			// service ok
			loader.classList.remove('active');
			analyticsService.dtmFormComplete('complete', '');
			thankYou.classList.add('active');
		}).catch(function (response) {
			// service failed
			analyticsService.dtmFormComplete('complete', '');
			loader.classList.remove('active');
			thankYou.classList.add('active');
		});
	}

}



// WEBPACK FOOTER //
// ./components/form-item-mail-form/form-item-mail-form.component.ts